import { Injectable } from "@angular/core";
import { AppSessionService } from "../session/app-session.service";
import { HttpClient } from "@angular/common/http";
import { AppConsts } from "../AppConsts";
import { filter as _filter, merge as _merge } from 'lodash-es';
import { WorkOrderSharedService } from "@app/departmental-functions/work-order/create-or-edit-work-order/work-order-shared-service/work-order-shared.service";
@Injectable({
    providedIn: 'root'
})
export class AbpUserRefreshConfigurationService {

    constructor(
        private _httpClient: HttpClient,
        private _sessionService: AppSessionService,
        private _workOrderShared: WorkOrderSharedService,
    ) {}

    refresh(): Promise<void> {
        const cookieLangValue =
            abp.utils.getCookieValue('Abp.Localization.CultureName');

        const token = abp.auth.getToken();

        const headers: any = {
            'Abp.TenantId':
                `${abp.multiTenancy.getTenantIdCookie()}`,
            '.AspNetCore.Culture':
                `c=${cookieLangValue}|uic=${cookieLangValue}`,
        };

        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }

        return this._httpClient
            .get<any>(
                `${AppConsts.remoteServiceBaseUrl}/AbpUserConfiguration/GetAllConfig`,
                { headers }
            )
            .toPromise()
            .then(response => {

                const result = response.result;
                this._workOrderShared.refreshSideBar$.next(true);
                _merge(abp, result);

                return this._sessionService.init();
            })
            .then(() => undefined);
    }
}
